import restaurantInstance from '../../instance'

const swapTable = (tableId, data) => {
  return restaurantInstance.put(`/tables/${tableId}/swap`, data)
}

export default swapTable
